"use client";

import { createContext, useContext } from "react";

export const FloatingPortalContainerContext = createContext<HTMLElement | null>(null);

export const useFloatingPortalContainer = () => useContext(FloatingPortalContainerContext);
